class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

// Bhavyata: native cart-code updates; automatic product discounts are preserved.
async function bhUpdateCartDiscounts(value) {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(root + 'cart/update.js', {
    method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({discount: value})
  });
  const cart = await response.json();
  if (!response.ok) throw new Error(cart.description || 'Unable to update the discount. Please try again.');
  const sidebar = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  if (sidebar && window.sharedFunctions?.updateSidebarCart) {
    window.sharedFunctions.updateSidebarCart(cart);
  } else if (sidebar) {
    const markup = await fetch(root + 'cart?view=ajax_side_cart', {cache:'no-store'}).then(r => {
      if (!r.ok) throw new Error('Unable to refresh your cart. Please try again.');
      return r.text();
    });
    sidebar.innerHTML = markup;
    document.dispatchEvent(new CustomEvent('cart-update', {detail:cart}));
  } else {
    window.location.reload();
  }
  return cart;
}

class CouponCode extends HTMLElement {
  constructor() {
    super();
    const field = this.querySelector('input[name="discount"]');
    const button = this.querySelector('[data-update-coupon]');
    if (!field || !button) return;
    field.value = localStorage.getItem('storedDiscount') || '';
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      const value = field.value.trim();
      button.disabled = true;
      let message = this.querySelector('[data-bh-coupon-status]');
      if (!message) {
        message = document.createElement('p');
        message.setAttribute('data-bh-coupon-status', '');
        message.setAttribute('role', 'status');
        this.appendChild(message);
      }
      try {
        await bhUpdateCartDiscounts(value);
        if (value) localStorage.setItem('storedDiscount', value);
        else localStorage.removeItem('storedDiscount');
        document.querySelector('.popup-toolDown.show')?.classList.remove('show');
        document.querySelector('.previewCart')?.classList.remove('active-tool');
      } catch (error) { message.textContent = error.message; }
      finally { button.disabled = false; }
    });
  }
}
customElements.define('coupon-code', CouponCode);

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bh-remove-discount]');
  if (!button || button.disabled) return;
  event.preventDefault();
  button.disabled = true;
  const status = document.querySelector('[data-bh-cart-status]');
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw new Error('Unable to read your cart. Please try again.');
    const current = await response.json();
    const removing = button.dataset.bhRemoveDiscount.toUpperCase();
    const codes = (current.discount_codes || []).filter(code => code.code.toUpperCase() !== removing).map(code => code.code);
    await bhUpdateCartDiscounts(codes.join(','));
    const stored = localStorage.getItem('storedDiscount') || '';
    const remaining = stored.split(',').map(code => code.trim()).filter(code => code && code.toUpperCase() !== removing);
    if (remaining.length) localStorage.setItem('storedDiscount', remaining.join(','));
    else localStorage.removeItem('storedDiscount');
  } catch (error) {
    if (status) { status.hidden = false; status.textContent = error.message; }
    button.disabled = false;
  }
});
